import { createContext, createElement, useContext, useReducer } from 'react';
import type { Mutation } from './mutations';
import type { State } from './types';
import { reducer } from './mutations';

export interface MetricsStore {
  state: State;
  dispatch: React.Dispatch<Mutation>;
}

const initialState: State = {
  data: {
    attendance: [],
    team: [],
    members: [],
  },
  loaded: false,
};

export const MetricsContext = createContext<MetricsStore>({
  state: initialState,
} as MetricsStore);

export function MetricsStoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return createElement(
    MetricsContext.Provider,
    { value: { state, dispatch } },
    children,
  );
}

export function useMetricsStore() {
  return useContext(MetricsContext);
}
